<template>
<div class="calendar">
  <div class="tipInfo">
    <div class="status">
      <img class="statusIco" src="@/assets/images/carSetting/ico3.png"/>可租
    </div>
    <div class="status">
      <img class="statusIco" src="@/assets/images/carSetting/ico2.png"/>部分时间可租
    </div>
    <div class="status">
      <img class="statusIco" src="@/assets/images/carSetting/ico1.png"/>不可租
    </div>
  </div>
  <div class="monthBlock">
    <div class="title">
      <div class="titleWeek" v-for="(item,index) in weekList" :key="index">{{item}}</div>
    </div>
    <div class="days">
      <div v-for="(item,index) in rentdays" :key="index">
        <div class="noday" v-if="JSON.stringify(item) == '{}'"></div>
        <div :class="['day',item.Status == 3 ? 'noRent' : '',item.Status == 2 ? 'partlyRented' : '']" v-else>
          <span>{{item.RentDate}}</span>
          <span class="blue">￥{{item.Price}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import {getDay} from "@/utils/formatDate";
  import { rentTime } from "@/utils/api";
    export default {
      name: "calendar",
      data: function () {
        return {
          CarID:0,
          weekList: ["日", "一", "二", "三", "四", "五", "六"],
          rentdays:[]
        };
      },
      components: {

      },
      created() {
        this.CarID = this.$route.query.CarID || 0;
      },
      mounted() {
        this.initData();
      },
      methods: {
        async initData(){
          let res =  await rentTime({
            data:{
              CarId:this.CarID
            }
          })
          if(res.Code == 100){
            let date = res.Data[0].RentDate.slice(0,10);
            let day = getDay(date) == 6 ? 0 : getDay(date);

            for(let m=0;m<res.Data.length;m++){
              res.Data[m].RentDate = res.Data[m].RentDate.slice(8,10);
            }
            this.rentdays = res.Data;
            for (let i = day; i > 0; i--) {
              this.rentdays.unshift({});
            }
          }
        }
      }
    }
</script>

<style scoped lang="scss" type="text/scss">
  .calendar {
    position: absolute;
    width: 100%;
    height: auto;
    top: 110px;
    bottom: 0px;
    left: 0px;
    padding: 0px 35px;
    box-sizing: border-box;
    background: #fff;
    font-size: 26px;
    overflow: scroll;
    .tipInfo{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin: 30px 0;
      color: #9F9F9F;
      font-size: 26px;
      .status{
        display: flex;
        align-items: center;
        margin-right: 30px;
        .statusIco{
          margin-right: 10px;
          width: 40px;
          height: 40px;
        }
      }
    }
    .monthBlock{
      margin-bottom: 38px;
      padding: 30px 35px;
      box-sizing: border-box;
      text-align: center;
      width: 680px;
      box-shadow: 0 0 6px #ccc;
      -webkit-box-shadow: 0 0 6px #ccc;
      .name{
        width: 100%;
        font-size: 32px;
      }
      .title{
        display: flex;
        justify-content: space-around;
        margin-top: 35px;
      }
      .days{
        display: flex;
        flex-wrap: wrap;
        padding-top: 20px;
        box-sizing: border-box;
        .noday{
          width: 80px;
          margin: 3px;
        }
        .day{
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin: 3px;
          width: 80px;
          height: 90px;

          border: 1px dashed #9f9f9f;/*no*/
          box-sizing: border-box;
          span{
            display: flex;
            justify-content: center;
          }
          .blue{
            color: #027FFF;
            font-weight: bold;
            font-size: 22px;
          }
        }
        .noRent{
          background: #EBEBEB;
        }
        .partlyRented{
          background-image:-webkit-linear-gradient(top, #EBEBEB 50%, #FFFFFF 0% )
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/car/calendar.vue